import React from 'react';
import type ProductsJswConfigurationType from '@jira/spa-apps__admin-pages-products-jsw-configuration/src/ProductsJswConfigurationType.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazySystemConfigurationGeneral: LazyComponent<() => React.JSX.Element> = lazyForPaint<
	typeof ProductsJswConfigurationType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-system-configuration-general", jiraSpaEntry: "async-system-configuration-general" */ '@jira/spa-apps__admin-pages-system-configuration-general/src/SystemConfigurationGeneralSwitcher.tsx'
		),
	),
);

const AsyncSystemConfigurationGeneral = (): React.JSX.Element => (
	<LazyPage
		Page={LazySystemConfigurationGeneral}
		pageId="system-configuration-general"
		shouldShowSpinner={false}
	/>
);

export default AsyncSystemConfigurationGeneral;
